import React from 'react';
import { Network, Users, Cpu, Shield, Award } from 'lucide-react';

const CapabilitiesSection = () => {
  const capabilities = [
    {
      icon: Network,
      title: 'Adaptive Governance & Decision Systems',
      description: 'Continuation of compliance and cybersecure resilience in constantly changing economic and digital landscapes is complex. We get engaged to address the constant demand for process and technology evolution. Our architects bring a proficiency to the change model and investment decisions process saving your organization risk while assuring resilience.',
      outcome: 'Integrated operations decision logic, clear accountability, faster digital advancement execution.'
    },
    {
      icon: Users,
      title: 'Organizational Design & Operating Alignment',
      description: 'Integrated impacts of outdated operations and service models have growing complexity with AI and talent upskilling requirements. Our specialists help organizations resolve misalignment of business, technology and talent performance architectures that obstruct rather than enable execution.',
      outcome: 'Coherent structures, empowered teams, and sustainable agility.'
    },
    {
      icon: Cpu,
      title: 'Human + AI Workforce Intelligence',
      description: 'Integration of AI into decision making is simplified through upskilling your people strategically. Ability, character, and environment are pillars of influence in building true appropriated adaptability. We combine impact assessments and the leading-edge adaptability quotient tools with experience and data backed perspectives to create compelling cases for change.',
      outcome: 'Human judgement amplified by data; ethical automation; measurable adaptive capacity.'
    },
    {
      icon: Shield,
      title: 'Operational Durability & Continuity',
      description: 'Resilience is not recovery; it requires systems thinking to integrate operational risk, data assurance, and cultural adaptability into unified architectures. Our engineers and change leaders are adept at synchronized decision making. Real-time insights, personalized dashboards, insurance and regulatory compliance, environment, social and governance all integrate to advance your strategic goals.',
      outcome: 'Foresight, autonomous integrity, and under high-fidelity continuity under volatility'
    },
    {
      icon: Award,
      title: 'Embedded Leadership & Stewardship',
      description: 'Our fractional talent specialists provide interim leadership, architectural transition guidance, sales, business development, technology, and business subject matter experts to anchor your business performance as you adopt new ways of working.',
      outcome: 'Fiscal efficiency, strategic velocity, dynamic relevance and resilient innovation.'
    }
  ];

  return (
    <section id="capabilities" className="capabilities-section">
      <div className="capabilities-container">
        <div className="section-header">
          <h2 className="section-title">What We Enable</h2>
          <p className="section-subtitle">
            At our core, we focus on what matters most: your customer care-abouts and the vitality of your business. We bring expertise to identify opportunities to bridge the gap between traditional even antiquated operations and the exponentially accelerated requirement to embrace technological advancements. Our goal is to advance business, technology, and workforce architectures to ensure vitality, adaptability, and resilience.
          </p>
        </div>

        <div className="capabilities-grid">
          {capabilities.map((capability, index) => {
            const IconComponent = capability.icon;
            return (
              <div key={index} className="capability-card">
                <div className="capability-icon">
                  <IconComponent size={40} />
                </div>
                <h3 className="capability-title">{capability.title}</h3>
                <p className="capability-description">{capability.description}</p>
                <div className="capability-outcome">
                  <span className="outcome-label">Outcome:</span>
                  <span className="outcome-text">{capability.outcome}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;